"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.decideOptions = exports.getObjectFromLocalStorage = exports.saveObjectInLocalStorage = exports.getWorkspaceOptions = exports.getTransferGroupsOptions = exports.getAreaOptions = exports.getCountryOptions = void 0;
const store_1 = __importDefault(require("@app/store"));
const getCountryOptions = (countries) => countries.map((country) => ({
    label: country.code,
    value: country.id,
}));
exports.getCountryOptions = getCountryOptions;
const getAreaOptions = (countries) => countries
    .map((country) => {
    return country.areas.map((area) => ({
        groupTitle: country.code,
        label: area.name,
        value: area.id,
    }));
})
    .flat();
exports.getAreaOptions = getAreaOptions;
const getTransferGroupsOptions = (transferGroups) => {
    return transferGroups?.map((gp) => ({
        label: gp.name,
        value: gp.id,
    }));
};
exports.getTransferGroupsOptions = getTransferGroupsOptions;
const getWorkspaceOptions = (countries, { alwaysShowCountry = false } = {}) => countries
    .map((country) => {
    return country.areas
        .map((area) => {
        return area.workspaces.map((workspace) => {
            const prefix = countries?.length > 1 && country?.code ? country.code + ' ' : '';
            // alwaysShowCountry (opt-in): surface the country as a third level in
            // the group label ("(CZ) Area"), even for single-country orgs. Default
            // keeps the original behaviour (country prefix only when >1 country).
            const groupTitle = alwaysShowCountry && country?.code
                ? `(${country.code}) ${area.name || ''}`
                : prefix + (area.name || '');
            return {
                groupTitle,
                label: workspace.name,
                value: workspace.id,
                enforceLocalities: workspace.enforceLocalities,
                localities: workspace.localities,
                country: country.code,
            };
        });
    })
        .flat();
})
    .flat();
exports.getWorkspaceOptions = getWorkspaceOptions;
// saves an object 'obj' in local storage under key 'uniqueKey'
const saveObjectInLocalStorage = (uniqueKey, obj, callbackFn = null) => {
    const { organizationId } = store_1.default.getState();
    let stored = window.localStorage.getItem('ds-org-persistent-state');
    if (stored) {
        stored = JSON.parse(stored);
    }
    else {
        stored = {};
    }
    const orgAsStr = organizationId || '';
    stored[orgAsStr + '_' + uniqueKey] = obj;
    window.localStorage.setItem('ds-org-persistent-state', JSON.stringify(stored));
};
exports.saveObjectInLocalStorage = saveObjectInLocalStorage;
// returns either the 'defaultObject' or its cached version from local storage, if it's there, under the 'uniqueKey'
const getObjectFromLocalStorage = (uniqueKey, defaultObject) => {
    const { organizationId } = store_1.default.getState();
    const stored = window.localStorage.getItem('ds-org-persistent-state');
    const orgAsStr = organizationId || '';
    if (stored && JSON.parse(stored)[orgAsStr + '_' + uniqueKey]) {
        return JSON.parse(stored)[orgAsStr + '_' + uniqueKey];
    }
    else {
        return defaultObject;
    }
};
exports.getObjectFromLocalStorage = getObjectFromLocalStorage;
const decideOptions = (showBy, countries) => {
    switch (showBy) {
        case 'countries':
            return (0, exports.getCountryOptions)(countries);
        case 'areas':
            return (0, exports.getAreaOptions)(countries);
        case 'workspaces':
            return (0, exports.getWorkspaceOptions)(countries);
        default:
            return [];
    }
};
exports.decideOptions = decideOptions;
